import script from "./HrTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./HrTabs.vue?vue&type=script&setup=true&lang=js"

import "./HrTabs.vue?vue&type=style&index=0&id=57ab66c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ab66c0"]])

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab});
